export const GET_SOURCE_LOCALIZATIONS = 'GET_SOURCE_LOCALIZATIONS';
export const GET_SOURCE_LOCALIZATION_BY_ID = 'GET_SOURCE_LOCALIZATION_BY_ID';
export const UPDATE_SOURCE_LOCALIZATION = 'UPDATE_SOURCE_LOCALIZATION';
export const DELETE_SOURCE_LOCALIZATION = 'DELETE_SOURCE_LOCALIZATION';
export const CREATE_SOURCE_LOCALIZATION = 'CREATE_SOURCE_LOCALIZATION';
